<template>
  <div class="feedback-list">
    <div v-if="feedbackList.length === 0" class="no-feedback flex flex-col items-center justify-center">
      <v-icon size="48" color="gray">mdi-alert-circle-outline</v-icon>
      <p class="no-data-text mt-2">No Previous Records Found</p>
    </div>
    <div v-else>
      <h3>My Feedbacks</h3>
      <table class="feedback-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Feedback</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in feedbackList" :key="item.id">
            <td>{{ formatDate(item.created_at) }}</td>
            <td>{{ item.text }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    feedbackList: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return "N/A";

      let date;
      if (timestamp.seconds !== undefined) {
        date = new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
      } else if (timestamp instanceof Date) {
        date = timestamp;
      } else {
        return "Invalid Date";
      }

      return date.toLocaleString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
    }
  }
};
</script>

<style scoped>
.feedback-list {
  margin-top: 20px;
}
.no-feedback {
  padding: 20px;
  text-align: center;
}
.no-data-text{
  color: gray;
}
.feedback-table {
  width: 100%;
  border-collapse: collapse;
}
.feedback-table th, .feedback-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}
.feedback-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}
</style> 